import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function CoachNote() {
  return (
    <section className="py-24 md:py-40 border-b border-white/10" data-testid="coach-note-section">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="max-w-4xl">
          <motion.div {...reveal} transition={{ duration: 0.7 }}>
            <p className="font-display uppercase tracking-[0.3em] text-xs text-gold mb-6">A Word From Your Coach</p>
            <Quote className="w-10 h-10 text-gold mb-8" aria-hidden="true" />
          </motion.div>

          <motion.div {...reveal} transition={{ duration: 0.7, delay: 0.1 }} className="space-y-8" data-testid="coach-note-body">
            <p className="font-display font-semibold uppercase text-3xl md:text-5xl leading-[1.05] tracking-tight text-white">
              When it comes to training, everything has to have a purpose. A reason.{" "}
              <span className="text-gold italic">"Quality over quantity"</span> isn't just a saying
              here — it's the standard.
            </p>
            <p className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
              Every exercise we do together is chosen for you. Every rep is directed and performed
              with intent. Your goals — inside and outside the gym — are always the priority.
            </p>
            <p className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
              One hour at a time, we give 100%. Serious hard work, absolutely — but a laugh is
              non-negotiable.
            </p>
          </motion.div>

          <motion.div {...reveal} transition={{ duration: 0.7, delay: 0.2 }} className="mt-12 flex items-center gap-4">
            <span className="h-px w-12 bg-gold" aria-hidden="true" />
            <p className="font-display uppercase tracking-[0.2em] text-sm text-white" data-testid="coach-note-signoff">
              Harry <span className="text-zinc-500">— Head Coach, OSHPerformance</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
